module.exports = __webpack_public_path__ + "img/Cccc.51bea1a5.png";